// extracted by mini-css-extract-plugin
module.exports = {"event__editor":"event__editor__2qg8X","error":"error__1Rh-Y","event__editor__dragzone":"event__editor__dragzone__17qvR"};